import {DateFilterType, DateFilterTypeName} from "../../components/v5/filters/dateFilter/DateFilter";
import {FilterValueApiDto} from "../../api/model/rest";

export default class DateFilterModel {
	constructor(public readonly radioButtonId: DateFilterType) {}

	getDisplayValue() {
		return `${DateFilterTypeName[this.radioButtonId]}`
	}

	toQueryJson(dateFormat?: string): FilterValueApiDto[] {
		return null
	}
}